import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { tpoGenUrls } from 'config/urls';

interface UpliftPPGPayload {
    dim1_id: number;
    promo_metrics: Record<string, number>;
}

interface UpliftRequestPayload {
    plan_id: string;
    promotion_id: string;
    attributes: Record<string, unknown>;
    dim2_name: string;
    offer_details: unknown;
    ppgs: UpliftPPGPayload[];
}

interface UpliftPPGResponse {
    dim1_id: number;
    tpo_uplift_percent: number;
}

interface UpliftResponse {
    results: UpliftPPGResponse[];
}

/** POST /tpo_gen/promos/model_uplift — returns predicted uplift % per PPG */
const fetchUpliftRecommendation = async (payload: UpliftRequestPayload): Promise<UpliftResponse> => {
    const token = localStorage.getItem('accessToken');
    const response = await axios(tpoGenUrls.getUpliftRecommendation, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        data: payload,
    });
    return response.data;
};

interface UseUpliftMutationOptions {
    onSuccess?: (data: UpliftResponse) => void;
}

/**
 * Mutation hook for the model uplift API.
 * Network-only concern — response consumption is handled by the caller (useUpliftTrigger).
 */
const useUpliftMutation = ({ onSuccess }: UseUpliftMutationOptions = {}) => {
    const { mutateAsync, isPending } = useMutation({
        mutationFn: fetchUpliftRecommendation,
        onSuccess,
        onError: (error: unknown) => {
            console.error('Uplift API Failed:', error);
        },
    });

    return { mutateAsync, isPending };
};

export type { UpliftRequestPayload, UpliftPPGPayload, UpliftPPGResponse, UpliftResponse };
export default useUpliftMutation;
